module.exports = __webpack_public_path__ + "img/agent-task.86511363.png";